// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Hkd","newExpiryDate":"styles_newExpiryDate__2zYJI","footer":"styles_footer__21m5N"};